import { ResourcePage } from "./ResourcePage";

export function KubernetesClusters() {
  return (
    <ResourcePage
      type="KubernetesCluster"
      typeLabelSentence="Kubernetes cluster"
      typeLabelPlural="Kubernetes clusters"
      kindOptions={["Generic", "AKS", "EKS", "GKE"]}
      defaultPort={443}
    />
  );
}
